export default __webpack_public_path__ + "locales/lo-LA/Payments.json?hash=d39bd116438edb27df208873e3f47868";